import React, { useMemo } from 'react';
import { Col, Row } from 'antd';
import styles from './style.module.scss';
import { useTranslation } from 'react-i18next';
import LeftCardsSection from 'components/leftCardsSection';
import { useNavigate } from 'hooks/useNavigate';
import { Route, Routes } from 'react-router-dom';
import AddTeam from './addTeam';
import TeamList from './teamList';
import UsersList from './usersList';

const ManagerView = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  const sectionData = useMemo(
    () => [
      {
        title: t('Membri del tuo team'),
        description: '',
        btnText: t('Aggiungi'),
        btnAction: () => navigate('add'),
      },
      {
        title: t('Il tuo team'),
        description: '',
        btnText: t('Vedi'),
        btnAction: () => {
          navigate('list');
        },
      },
    ],
    [t, navigate],
  );

  return (
    <Row className={styles.container} gutter={20}>
      <Col span={6}>
        <LeftCardsSection title={t('Team')} sectionData={sectionData} />
      </Col>
      <Col span={18}>
        <Routes>
          <Route path={'add/*'} element={<AddTeam />} />
          <Route path={'list/:id/edit'} element={<AddTeam isEdit />} />
          <Route path={'list/*'} element={<TeamList />} />
        </Routes>
      </Col>
    </Row>
  );
};

export default ManagerView;
